/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;
declare var svg4everybody : any;

module navigation {
  'use strict';

  export class MenuCtrl {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      '$location', 
      '$anchorScroll', 
      '$window', 
      '$http', 
      'userService',
      'shoppingListService',
      'anchorNavService',
      'pageMetaService',
      'loadingIndicatorService',
      'parallaxService',
      '$mdDialog',
      '$animate',
      
    ];

    // dependencies are injected via AngularJS $injector
    constructor(
      private $scope: IMenuScope,
      private $location: ng.ILocationService,
      private $anchorScroll: ng.IAnchorScrollService,
      private $window: ng.IWindowService,
      private $http: ng.IHttpService,
      private userService: user.UserService,
      private shoppingListService: shoppinglist.IShoppingListService,
      private anchorNavService : navigation.IAnchorNavService,
      private pageMetaService: navigation.IPageMetaService,
      private loadingIndicatorService : navigation.LoadingIndicatorService,
      private parallaxService: navigation.IParallaxService,
      private $mdDialog: ng.material.IDialogService,
      private $animate : ng.animate.IAnimateService
      ) {
     
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      
      var el : any = $("#navigation")
      //el.stick_in_parent({offset_top : -10 });

      //window.ace.version
      //window..angular.version.full
      //window..ngMaterial.version.full

      var lastScrollTop : number = 0;
      var pos : number = 0;
      var currentHeaderHeight : number = 0;

      var animateHeader = (scrollTop : number) => {
        //pos holds the 'animation' position 0 will be expanded 1 will be collapsed.
        pos += (scrollTop - lastScrollTop);
        lastScrollTop = scrollTop;




        var headerSpeed = 92;
         
        if ($window.matchMedia( "(min-width: 768px)" ).matches) { 
           headerSpeed = 188;
        }

        pos = Math.max(Math.min(pos, headerSpeed), 0);
        
        var toolsOpacity = this.parallaxService.easeInOutQuad(pos, 1, -1, headerSpeed, false);
        //var borderBottomOpacity = this.parallaxService.easeInOutQuad(scrollTop, 1, -1, headerSpeed, false);
        var shadowOpacity = this.parallaxService.easeInOutQuad(scrollTop, 0, 0.15, headerSpeed, false);
        var shadowBlur = this.parallaxService.easeInOutQuad(scrollTop, 0, 12, headerSpeed, false);
        var shadowSpread = this.parallaxService.easeInOutQuad(scrollTop, 0, 2, headerSpeed, false);
        var l1LinkPaddingBottom = this.parallaxService.easeInOutQuad(pos, 14, 34, headerSpeed, false);
        var subnav = this.parallaxService.easeInOutQuad(pos, 60, -60, headerSpeed, false);

        var logoScale = 1
        var headerHeight = 90;        
        var logoBottom = 5;        

        headerHeight = this.parallaxService.easeInOutQuad(pos, headerSpeed, -27, headerSpeed);
        logoScale = this.parallaxService.easeInOutQuad(pos, 1, -0.3333333333, headerSpeed, false);

        //xs+
        if ($window.matchMedia( "(min-width: 480px)" ).matches) {
        }

        //sm+
        if ($window.matchMedia( "(min-width: 768px)" ).matches) {   
          logoScale = 1
          headerHeight = this.parallaxService.easeInOutQuad(pos, headerSpeed, -78, headerSpeed);
          logoBottom = this.parallaxService.easeInOutQuad(pos, 27, -9, headerSpeed);        
        }

        //md+
        if ($window.matchMedia( "(min-width: 992px)" ).matches) {
          //logoScale = 0.86;
          logoScale = this.parallaxService.easeInOutQuad(pos, 1, -0.14, headerSpeed, false);

        }

        //lg+
        if ($window.matchMedia( "(min-width: 1200px)" ).matches) {       
          logoScale = this.parallaxService.easeInOutQuad(pos, 1, -0.3333333333, headerSpeed, false);
        }

        currentHeaderHeight = headerHeight;        
        //$('.pagehead .header').css({ "border-bottom-color": "rgba(151, 151, 151, " + (1 - borderBottomOpacity) + ")" });
        $('.pagehead .header').css({ "box-shadow": "0 0 " + shadowBlur + "px " + shadowSpread + "px rgba(0, 0, 0,"+ shadowOpacity +")" });
         

        $('.pagehead .logopnl').css({ transform: "scale(" + logoScale + ")", "bottom" : logoBottom + "px" });
        $('.pagehead .header > .page-el').css({ height: headerHeight + "px" });
        $('.pagehead .tools').css({ opacity: toolsOpacity });
        $('.pagehead nav.main ul a').css({ "padding-bottom": l1LinkPaddingBottom + "px" }); 
        $('.pagehead nav.scroll ul').css({ transform: "translateY(" + subnav + "px)",  opacity: (1 - toolsOpacity), "z-index" : (1 - toolsOpacity) > 0.5 ? 20 : 0 }); 
        $('.pagehead nav.scroll').css({ "z-index" : (1 - toolsOpacity) > 0.5 ? 20 : 0 }); 
        $('.glossar .index').css({ top : headerHeight + 'px'});

      }
            
      this.parallaxService.subscribeOnScroll($scope, (e: ng.IAngularEvent, scrollTop : number) =>  {
        //collapse navigation on scrolling, when not on mobile
        if ($scope.showNav && $window.matchMedia( "(min-width: 768px)" ).matches) { 
          $scope.$apply(function () {
            $scope.showNav = false;
          });
        }
        var r = this.parallaxService.easeInOutQuad(scrollTop - 210, 55, -55, 500);
        $('.topflag').css({ transform: "translate3d(" + r + "px, 0, 0)" });

        animateHeader(scrollTop);
      });      

      $scope.$watch("showNav", (newValue, oldValue, scope) =>  {
        if (newValue == oldValue) return;
        if (newValue) { 
          $animate.animate($('.pagehead .subnav'), { 'max-height': 0 }, { 'max-height': $($window).height() - currentHeaderHeight + "px" });
        } else {       
          $animate.animate($('.pagehead .subnav'), { 'max-height': $('.pagehead .subnav').outerHeight(true) + "px" }, { 'max-height': 0 }).then(() => {
            //this.$scope.parentSubNav1 = undefined;
          });
        }
      });

      anchorNavService.getNavigationData().then((data : MenuNode[]) => {
        $scope.menudata = data;
        $scope.level = 0;
        anchorNavService.resetActivePath($scope.menudata);
        anchorNavService.findAndMarkCurrentNode($scope.menudata);
        animateHeader($(this.$window).scrollTop());        
      });
      

      anchorNavService.subscribeOnLocationChanged($scope, (event : ng.IAngularEvent, re: IRouteEntry) => {
        anchorNavService.resetActivePath($scope.menudata);
        anchorNavService.findAndMarkCurrentNode($scope.menudata);
        animateHeader($(this.$window).scrollTop());    
      });
      

      loadingIndicatorService.subscribeOnLoadIndicatorChanged($scope, (event : ng.IAngularEvent, requestOnGoing : boolean) => {
        $scope.requestOnGoing = requestOnGoing;
      });
      

      svg4everybody(); 

      $scope.shoppingListTotalMap = {1: 0, 2: 0};

      angular.forEach(shoppingListService.getLists(), (list : shoppinglist.ShoppingList, key : string)  =>  {
        $scope.shoppingListTotalMap[list.Type] = shoppingListService.getTotalQty(list);        
      });

      shoppingListService.subscribeOnUpdated($scope, (event, list) =>  {
        $scope.shoppingListTotalMap[list.Type] = shoppingListService.getTotalQty(list);
      });

    }

    getScrollNav() {
      var ani : AnchorNavItem[] = this.anchorNavService.getElements().filter((nsi) => {
        return nsi.useInScrollNav;
      });
      return ani;
    }

    isActiveScrollNav(ani : AnchorNavItem) {
      if (!this.anchorNavService.getActiveNavItem() || !ani) return false;
      return this.anchorNavService.getActiveNavItem().key.indexOf(ani.key) == 0; //starts with
    }

    

    setParentSubnav1(menuentry : MenuNode, notoggle? : boolean) {
      if (this.$scope.showNav && this.$scope.parentSubNav1 == menuentry && !notoggle) {
        this.$scope.showNav = false;
        return;
      }

      this.$scope.parentSubNav1 = menuentry;
      this.$scope.parentSubNav2 = menuentry.Nodes[0];

      var scope : IMenuScope = this.$scope;

      menuentry.Nodes.forEach(function(value : MenuNode, index : number, arr : MenuNode[]) {
        if (value.IsCurrent) scope.parentSubNav2 = value;
      });
      
      this.$scope.showNav = true;
      this.$scope.level = 1;   
    };  

    setParentSubnav2(menuentry : MenuNode) {
      this.$scope.parentSubNav2 = menuentry;
      this.$scope.level = 2;   
    };

    getMenuClass(menuentry) {
      if (!menuentry || !menuentry.Options) return 'text';
      if (menuentry.Options['Icon']) return 'icon';
      if (menuentry.Options['Image']) return 'img';
      return 'text';
    };

    getOptionWPrefix(menuentry, option, prefix) {
      if (!menuentry || !menuentry.Options) return null;
      return prefix + menuentry.Options[option];
    };

    gotoTop() {
      (<any>$).smoothScroll(0);
    };

    logout() {
      var me = this;

      this.userService.logout().then((response) => { 
        me.$window.location.reload();
      }).catch((reason) => {  
        alert('logout unsuccessful'); 
      });

    }


    openLogin(ev: MouseEvent) {
      //alert("test");
      
      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'MobileLoginCtrl',
        templateUrl: 'user/MobileLoginController',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          parentScope: this.$scope
        },
      })
        .then(function () {
          console.log('Modal closed at: ' + new Date());
        }, function () {
          console.log('Modal canceled at: ' + new Date());
        });
    }

    showShoppingList(listType, $event : JQueryEventObject) {
      this.shoppingListService.show(listType, $event.currentTarget);
    }
    
    navigate(n : MenuNode, $event : ng.IAngularEvent) : void {
      
      //if base page is not the same we can not do it the ajax way.
      var path : MenuNode[] = this.anchorNavService.getMenuTreePath(this.$scope.menudata, n);
      if (path[0].PageId != pglob.RouteData.BasePageId) return; //we need a page refresh, so we'll use the href attribute.

      event.preventDefault(); //we can change inside this page, so prevent 'href' attribute.
            
      this.anchorNavService.resetActivePath(this.$scope.menudata);
      this.anchorNavService.updateRouteParameters(n.RouteEntry, true, this.$scope.menudata);
      this.$scope.showNav = false;
    }

    getUrlForLanguage(lkey : string) : string {
      var query = ""
      var path = this.$location.url();
      if (path && path.indexOf("?") >= 0) {
        query = path.substring(path.indexOf("?"))
      }
      return pglob.RouteData.RouteEntry.UrlByLanguage[lkey] + query;
    }

    openChangePasswordModal(ev: MouseEvent) {
      this.$mdDialog.show(<ng.material.IDialogOptions>{
            controller: 'ChangePasswordCtrl',
            templateUrl: 'user/ChangePasswordDirective',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true, // Only for -xs, -sm breakpoints.
            locals: {
              parentScope: this.$scope
            },
          })
            .then(function () {
              console.log('Modal closed at: ' + new Date());
            }, function () {
              console.log('Modal canceled at: ' + new Date());
            });
    }
   
  }

}